export const geography = [
    {
      q: "Ко је написао прво дело под називом Географија?",
      a: ["Ератостен", "Колумбо", "Александар Хумболт", "Јосиф Панчић"],
    },
    {
      q: "Из које географије се развила географија становништва и насеља?",
      a: ["антропогеографије", "регионалне географије", "физичке географије", "економске географије"],
    },
    {
      q: "Ко се сматра оснивачем научне географије?",
      a: ["Александар Хумболт", "Јосиф Панчић", "Јован Цвијић", "Стари Грци"],
    },
    {
      q: "Ко је саставио прву географску карту?",
      a: ["Грк Анаксимандер", "Аристотел", "Стари Египћани", "Стари Кинези"],
    },
    {
      q: "Шта чини координатну мрежу географске карте?",
      a: ["упоредници и меридијани", "размер и ослоне тачке", "картографске пројекције и оквир карте", "размерник и азимутна пројекција"],
    },
    {
      q: "Шта од наведеног чини математичку основу карте?",
      a: ["размер", "упоредници", "упоредници и меридијани", "екватор"],
    },
    {
      q: "Размер карте може да буде:",
      a: ["бројчани и графички", "математички и бројчани", "координатни и графички", "купасти и азимутни"],
    },
    {
      q: "Како се називају замишљене линије које повезују полове и воде од севера према југу?",
      a: ["меридијани или подневци", "упоредници", "ослоне тачке", "ваљкасте пројекције"],
    },
    {
      q: "Шта је ослона тачка?",
      a: ["тачка у којој се секу упоредник и меридијан", "најнижа тачка у земљи", "тачка у којој се секу два меридијана", "раздаљина између Северног пола и последњег упоредника"],
    },
    {
      q: "Које картографске пројекције се најчешће користе у настави географије?",
      a: ["конвенционалне", "купасте", "ваљкасте", "азимутне"],
    },
    {
      q: "Код које картографске пројекције се мрежа упоредника и меридијана преноси на раван која додирује Земљину површину у једној тачки?",
      a: ["код азимутне", "код ваљкасте", "код купасте", "код математичке"],
    },
    {
      q: "Шта су изохипсе?",
      a: ["линије које повезују све тачке исте надморске висине", "линије које повезују места са истом густином насељености", "линије које повезују све планинске врхове у једној земљи", "линије које повезују градове са истим бруто друштвеним производом"],
    },
    {
      q: "Планови су карте које се израђују у размери:",
      a: ["1:100 – 1:10 000", "1:25 000 – 1:100 000", "1:100 000 – 1:1 000 000", "1:300 000 – 1: 15 000 000"],
    },
    {
      q: "Како се географске карте деле према садржини?",
      a: ["опште и посебне карте", "азимутне и ваљкасте карте", "планови и топографске карте", "детаљне и специфичне карте"],
    },
    
    {
      q: "Како се назива исељавање становништва?",
      a: ["емиграција", "имиграција", "моба", "деградација"],
    },
    {
      q: "Како се назива досељавање становништва?",
      a: ["имиграција", "демиграција", "емиграција", "наталитет"],
    },
    {
      q: "Шта је печалбарство?",
      a: ["посебан облик полуномадског кретања", "досељавање становништва из села у градове", "дневно кретање радне снаге", "кретање становништва услед високог природног прираштаја"],
    },
    {
      q: "Како се изражава општа густина насељености?",
      a: ["бројем становника на једном квадратном километру површине", "бројем становника на десет квадратних метара површине", "бројем становника на једном квадратном метру површине", "бројем становника на једном квадратном километру обрадиве површине"],
    },
    {
      q: "Који делови Србије су захваћени процесом депопулације?",
      a: ["Војводина и централна Србија", "јужна и западна Србија", "западна и источна Србија", "источна Србија"],
    },
    {
      q: "Шта је анекумена?",
      a: ["област која није насељена", "област сталне људске насељености", "област са највећом густином насељености", "област са просечном густином насељености"],
    },
    {
      q: "Из ког писма се развила ћирилица?",
      a: ["из глагољице", "из алфабета", "из клинастог писма", "из хијероглифа"],
    },
    {
      q: "Ко је створио гласовно (фонетско) писмо?",
      a: ["Феничани", "Египћани", "Грци", "Кинези"],
    },
    {
      q: "Који народ је направио први компас?",
      a: ["Кинези", "Грци", "Шпанци", "Португалци"],
    },
    {
      q: "Како се називају џиновски системи спојених градова и конурбација?",
      a: ["мегалополиси", "светске конурбације", "ситиполиси", "урбанополиси"],
    },
    {
      q: "Шта је Боваш?",
      a: ["мегалополис Бостон Вашингтон", "тип земљишта", "конурбација у Боливији", "река у Русији"],
    },
    {
      q: "Шта се утврђује педолошком рејонизацијом?",
      a: ["просторна распрострањеност типова земљишта", "размештај становништва у једном рејону (територији)", "просторна распрострањеност флоре и фауне", "хидрографска мрежа различитих рејона (регија)"],
    },
    {
      q: "Како се назива однос између укупног броја пољопривредног становништва и јединице пољопривредне површине?",
      a: ["аграрна густина насељености", "рурална густина насељености", "рурално-аграрна густина насељености", "општа густина аграрне насељености"],
    },
    {
      q: "Којој раси припадају Пигмеји?",
      a: ["негроидној", "жутој", "белој", "мешовитој"],
    },
    {
      q: "Где живи 90% кинеског становништва?",
      a: ["у Унутрашњој (Правој) Кини", "у Спољашњој Кини", "на Тибету", "у Монголији"],
    },
    {
      q: "Где се налазе највеће светске резерве нафте?",
      a: ["у Саудијској Арабији", "у Бразилу", "у Аргентини", "на Новом Зеланду"],
    },
    {
      q: "Како се зове најважнија индустријска област Јапана?",
      a: ["Кејхин", "острво Кјушу", "Хоншу", "Шикоку"],
    },
    {
      q: "Који град је средиште кинеске текстилне индустрије?",
      a: ["Шангај", "Пекинг", "Харбин", "Нанјинг"],
    },
    {
      q: "Који је главни град Кеније?",
      a: ["Најроби", "Абуџа", "Адис Абеба", "Рабат"],
    },
    {
      q: "Где се развила цивилизација Маја?",
      a: ["на полуострву Јукатан (Мексико) и у Гватемали", "на високим Андима", "у Перуу", "у Боливији"],
    },
    {
      q: "Где се развила цивилизација Инка?",
      a: [" у Перуу и Боливији", "у Мексику", "у Египту", "на Анахуашкој висоравни Мексика"],
    },
    {
      q: "Која је највећа држава у Африци (по пространству)?",
      a: ["Алжир", "Чад", "Судан", "Либија"],
    },
    {
      q: "Која држава је највећи светски извозник банана?",
      a: ["Еквадор", "Етиопија", "Египат", "Бразил"],
    },
    {
      q: "Која је најважнија културна биљка појаса „Tierra templada” у тропској Америци?",
      a: ["кафа", "шећерна трска", "банана", "каучуково дрво"],
    },
    {
      q: "Како се назива група „црних острва“ у Океанији?",
      a: ["Меланезија", "Микронезија", "Полинезија", "Хаваји"],
    },
    {
      q: "Која острва чине најпознатију острвску групу у Полинезији?",
      a: ["Хавајска острва", "Малдивска острва", "Сејшели", "Маршалска острва"],
    },
    {
      q: "Који је главни град Колумбије?",
      a: ["Богота", "Лима", "Каракас", "Хавана"],
    },
    {
      q: "Који је главни град Новог Зеланда?",
      a: ["Велингтон", "Брајтон", "Мелбурн", "Сува"],
    },
    {
      q: "Који континент је најразуђенији?",
      a: ["Европа", "Азија", "Африка", "Јужна Америка"],
    },
    {
      q: "Колико становника имају варошице?",
      a: ["мање од 10 000", "више од 10 000", "од 10 000 до 25 000", "25 000 - 50 000"],
    },
    {
      q: "Која од наведених европских држава броји највише становника?",
      a: ["Немачка", "Луксембург", "Монако", "Шведска"],
    },
    {
      q: "На колико мора излази Русија?",
      a: ["на дванаест мора", "на једно море", "на шест мора", "на три мора"],
    },
    {
      q: "Како се називају простране четинарске шуме у Русији?",
      a: ["тајге", "тундре", "секвоје", "селваси"],
    },
    {
      q: "Шта се подразумева под појмом урбанизација?",
      a: ["повећање градског становништва и преношење градских утицаја на околну сеоску средину", "исељавање градског становништва у околна села", "повећање запослености градског становништва", "пораст услужних делатности у градовима"],
    },
    {
      q: "Шта су унутрашње или ендогене силе?",
      a: ["Земљина топлота и гравитација", "ерозија", "абразија", "ротација и револуција"],
    },
    {
      q: "Како се називају спора кретања пространих делова Земљине коре?",
      a: ["епирогени покрети", "абразивни покрети", "орогени покрети", "еолски покрети"],
    },
    {
      q: "Како се деле тектонски покрети?",
      a: ["на епирогене и орогене", "на ерозивне и акумулативне", "на еолске и глацијалне", "на набирање и раседање"],
    },
    {
      q: "Која кретања доводе до настајања најкрупнијих облика рељефа на Земљи?",
      a: ["епирогени покрети", "набирање", "раседање", "орогени покрети"],
    },
    {
      q: "Који покрети доводе до набирања и раседања слојева у литосфери?",
      a: ["орогени покрети", "епирогени покрети", "ерозија", "акумулација"],
    },
    {
      q: "Како настају веначне планине?",
      a: ["набирањем", "раседањем", "спуштањем терена", "ерозијом и акумулацијом"],
    },
    {
      q: "Који облици рељефа су највиши и најистакнутији у садашњем рељефу копна?",
      a: ["веначне планине", "громадне планине", "океански басени", "кањони и клисуре"],
    },
    {
      q: "Колико су високе средње планине?",
      a: ["од 1 000 до 2 000 метара", "од 300 до 500 метара", "од 1 500 до 2 500 метара", "од 2 000 до 4 000 метара"],
    },
    {
      q: "Како се стварају најкрупнији ерозивни облици рељефа на копну?",
      a: ["радом река", "радом језера", "радом таласа", "радом ветра"],
    },
    {
      q: "Како се називају заравњени терени на висинама изнад 200 метара?",
      a: ["висоравни или платои", "ниске планине", "депресије", "средње планине"],
    },
    {
      q: "Како се називају делови копна који леже испод нивоа мора?",
      a: ["депресије", "низије", "равнице", "акумулације"],
    },
    {
      q: "Шта су географска ширина, распоред копна и мора и надморска висина?",
      a: ["климатски фактори", "климатски елементи", "типови климе", "континентални климати"],
    },
    {
      q: "Који климатски тип је карактеристичан за јужну, југоисточну и источну Азију?",
      a: ["монсунски тип", "пустињски тип", "екваторијални тип", "тропски тип"],
    },
    {
      q: "Који климатски тип се јавља у умереном појасу?",
      a: ["средоземни (суптропски)", "тропски", "монсунски", "екваторијални"],
    },
    {
      q: "Који климат је карактеристичан за најсеверније пределе Европе, Азије и Северне Америке?",
      a: ["климат тундре", "климат пустиње", "климат северних земаља", "алпски климат"],
    },
    {
      q: "Који је зaједнички назив за сва мора и океане који чине јединствену водену површину?",
      a: ["Светски океан", "Атлантски океан", "Велики океан", "Велико море"],
    },
    {
      q: "Колико износи просечна дубина Светског океана?",
      a: ["3 700 метара", "9 800 метара", "2 650 метара", "11 034 метара"],
    },
    {
      q: "Колико промила износи просечан салинитет Светског мора?",
      a: ["35‰", "29‰", "62‰", "40‰"],
    },
    {
      q: "Како се назива површина са које се атмосферска вода слива – отиче у неку реку и њене притоке?",
      a: ["речни слив", "речна мрежа", "хидрографска мрежа", "речно корито"],
    },
    {
      q: "Које је језеро најдубље на свету?",
      a: ["Бајкалско језеро", "Каспијско језеро", "језеро Ири", "Велико језеро"],
    },
    {
      q: "Који тип земљишта је најплоднији?",
      a: ["црница", "црвеница", "смоница", "гајњача"],
    },
    {
      q: "Шта су селваси?",
      a: ["тешко проходне шуме у Јужној Америци", "тешко проходне шуме у Африци", "тешко проходне шуме у Азији", "тешко проходне шуме у Аустралији"],
    },
    {
      q: "Како се називају густе, тешко проходне шуме у Африци?",
      a: ["прашуме", "селваси", "џунгле", "тундре"],
    },
    {
      q: "Које биљке су карактеристичне за зону савана?",
      a: ["високе траве, усамљено дрвеће (баобаб) и акације са карактеристичним крошњама", "четинари", "ниске траве и високо дрвеће са бујним крошњама", "маховине и лишајеви"],
    },
    {
      q: "Како се дели привреда према начину размене и развијености?",
      a: ["на натуралну и робно-новчану", "на пољопривреду, шумарство и индустрију", "на услужне и производне делатности", "на руралну и урбану"],
    },
    {
      q: "Који тип пољопривреде је заступљен у већини земаља Азије и Африке?",
      a: ["натурални тип", "фармерски тип", "савански тип", "совхоски тип"],
    },
    {
      q: "У којој земљи се налази главна производна област кукуруза?",
      a: ["САД", "Русија", "Бразил", "Аргентина"],
    },
    {
      q: "Која земља је највећи светски произвођач вина?",
      a: ["Француска", "САД", "Швајцарска", "Нови Зеланд"],
    },
    {
      q: "Која земља је водећи светски произвођач пиринча?",
      a: ["Кина", "Јапан", "Индија", "Малезија"],
    },
    {
      q: "Које земље су највећи светски произвођачи меса?",
      a: ["Кина и САД", "Русија и Јапан", "Русија и Нови Зеланд", "Бразил и Аргентина"],
    },
    {
      q: "Које језеро је највеће на свету?",
      a: ["Каспијско", "Бајкалско", "Ђердапско", "Онтарио"],
    },
    {
      q: "Који град је главни град Белгије?",
      a: ["Брисел", "Лисабон", "Копенхаген", "Хаг"],
    },
    
  ]
